import React, {Fragment} from 'react';
import { Link } from "react-router-dom";
import closeIcon from "../../../semantic/src/themes/fibrestream/assets/images/close.svg";
import {connect} from 'react-redux'
import {setEmergencyMessage} from '../../../store/actions/app';

const Message = (props) => {
  if(!props.emergencyMessage)
  {
    return null;
  }

  const message = replaceStatus(props.emergencyMessage);

  function onClose(e)
  {
    props.setEmergencyMessage(null);
    props.onClose(e);
  }

  return <div className="notification text-white">
    <div className="btn--close"><img src={closeIcon} alt="" onClick={onClose} /></div>
    <div>{message}</div>
  </div>
}

function replaceStatus(emergencyMessage)
{
  let parts = `${emergencyMessage}`.split(" ");
  for(let i=0; i<parts.length; i++)
  {
    if(parts[i] === "##statuspage##")
    {
      parts[i] = <Fragment key={i}> <Link to={'/service-status'}>status page</Link>&nbsp;</Fragment>;
    }
    else
    {
      parts[i] += ' ';
    }
  }

  return parts;
}


const mapStateToProps = state => {
  return {
    emergencyMessage: state.app.emergencyMessage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setEmergencyMessage: () => dispatch(setEmergencyMessage())
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Message);


// WEBPACK FOOTER //
// ./src/components/header/message/Message.js